import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-contact-picklist',
  templateUrl: './contact-picklist.component.html'
})
export class ContactPicklistComponent implements OnChanges {
  all: any[] = [];

  @Input()
  contactCompanyId: any;

  @Input()
  contactDepartmentId: any;

  @Output()
  selectedItemsChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  selectedItems: string[];

  @Input()
  listMinSize: number = 5;

  onNgModelChange(e) {
    this.selectedItemsChange.emit(e);
  }

  constructor(private auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  reload() {
    if (!this.contactCompanyId) {
      this.all = [];
      return;
    }

    const params: HttpParams = new HttpParams()
      .set('contactCompanyId', this.contactCompanyId);

    return this.http.get(`${this.env.e.url}/auth/contacts/all`, {params: params})
      .subscribe(data => {
        this.all = (data as any[]).filter(contact =>
          !contact.contactDepartmentId ||
          (!!this.contactDepartmentId && contact.contactDepartmentId === this.contactDepartmentId)
        );
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['contactCompanyId'] || changes['contactDepartmentId']) {
      this.reload();
    }
  }
}
